class MangaApp
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log('MangaApp')

    //モーダル初期化
    if($('.manga-modal').length > 0) this.initModal()

    //漫画の初期化
    if($('.page-container').length > 0) this.initPages()
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	モーダル関連
	// ---------------------------------------------------------------------------------------------------------

  /**
   * 初期化
   */
  initModal()
  {
    //モーダル参照
    this.modal = $('.manga-modal')

    //閉じるボタン
    $('.manga-modal__close-btn').on('click', (e)=>{
      e.preventDefault()
      this.hideModal()
    })

    //キャラクター紹介ボタン
    $('.manga-index__chara-banner').on('click', (e)=>{
      e.preventDefault()
      this.showModal('chara')
    })
  }

  /**
   * 開く
   */
  showModal(type)
  {
    switch(type){
      case 'chara':
        this.modal.addClass('modal-type-chara')
        this.modal.removeClass('modal-type-author')
        break
      case 'author':
        this.modal.addClass('modal-type-author')
        this.modal.removeClass('modal-type-chara')
        break
    }

    this.modal.addClass('show')
  }

  /**
   * 閉じる
   */
  hideModal()
  {
    this.modal.removeClass('show')
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	漫画関連
	// ---------------------------------------------------------------------------------------------------------

  initPages()
  {
    //参照
    this.pageContainer = $('.page-container')
    this.moreBtn = $('.manga-btn-more')

    //漫画のつづきを読む
    this.moreBtn.on('click', (e)=>{
      e.preventDefault()

      //全ページ表示
      this.pageContainer.addClass('showall')

      //つづきを読むボタンを隠す
      this.moreBtn.hide()
    })

  }


  // ---------------------------------------------------------------------------------------------------------
}

$(function(){
  new MangaApp();
});
